import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(100vh - 240px)",
    overflowY: "auto",
    paddingTop: theme.spacing(1),
  },
  viewButtons: {
    display: "flex",
    justifyContent: "space-between",
  },
  subMenuHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  submitButtonBox: {
    display: "flex",
    justifyContent: "end",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
}));
